import { LockClosedIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../../Translations';
import { ProductCollectionKind } from '../../Types';

interface Props {
  kind: ProductCollectionKind;
}

type DescriptionKey =
  | 'Personalized recommendations will be shown to participants based on their profile.'
  | 'Dynamic recommendations will be shown based on participant activity.'
  | 'Group coaching sessions will be displayed to eligible participants.';

const getDescriptionKey = (kind: ProductCollectionKind): DescriptionKey | null => {
  switch (kind) {
    case 'recommendation-engine':
      return 'Personalized recommendations will be shown to participants based on their profile.';
    case 'dynamic-recommendation':
      return 'Dynamic recommendations will be shown based on participant activity.';
    case 'group-coaching':
      return 'Group coaching sessions will be displayed to eligible participants.';
    case 'learning-design':
    case 'ai-recommendation':
      // This case should never be reached - learning-designs don't use this component
      console.warn('[SystemManagedPlaceholder] Unexpected kind: learning-design');
      return null;
  }
};

function SystemManagedPlaceholder({ kind }: Props) {
  const descriptionKey = getDescriptionKey(kind);

  return (
    <div
      data-testid="system-managed-placeholder"
      data-intercom-target="system-managed-placeholder"
      className="flex flex-col items-center justify-center bg-muted/50 h-[14rem] rounded border-dashed border-2 border-border"
    >
      <div className="flex items-center gap-2 text-muted-foreground">
        <LockClosedIcon className="h-5 w-5" aria-hidden="true" />
        <span className="font-medium">
          <T kind="Managed by ExecOnline" />
        </span>
      </div>
      {descriptionKey && (
        <p className="mt-2 text-sm text-muted-foreground text-center max-w-md px-4">
          <T kind={descriptionKey} />
        </p>
      )}
    </div>
  );
}

export default SystemManagedPlaceholder;
